import { render, staticRenderFns } from "./FollowingSettingsView.vue?vue&type=template&id=fc5b7762&"
import script from "./FollowingSettingsView.vue?vue&type=script&lang=ts&"
export * from "./FollowingSettingsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports